<template>
    <h3>无封顶气垫(安全气囊)</h3>
    <!-- 搜索表单 -->
    <SearchForm @submit="fetchData" :isSubmitting="isSubmitting" />
    <!-- 表格区域 -->
    <div v-if="tableData.length > 0" class="table-container">
         <UncappedStockTable :tableData="filteredTableData" :now_str="now_str" />
    </div>


</template>

<script>
import axios from 'axios';
import SearchForm from '@/components/SearchForm.vue';
import UncappedStockTable from '@/components/UncappedStockTable.vue';

export default {
  name: 'StockSearchFormPage',
  components: {
    SearchForm,
    UncappedStockTable
  },
  data() {
    return {
      isSubmitting: false,
      date:'',
      searchQuery: '',
      stock_name:'',
      structure:'',
      stock_code:'',
      now_str:'',
      warring: '',
      tableData: [],
      originalTableData: [], // 添加原始数据副本
      selectedStructure: '100%',
      selectedStructure_amount: '1',
      selectedBrokerage: 'all', // 初始化为默认值
      containerDisplay: false
    };
  },
  computed: {
    filteredTableData() {
      let filteredData = this.tableData;
      return filteredData;
    }
  },
  methods: {

    async fetchData(searchData) {
  // 从 SearchForm 接收包含 query 和 date 的对象
  const { query, date } = searchData;

  if (this.isSubmitting) return;
  console.log('开始请求数据:', query);
  this.isSubmitting = true;
      try {
        const response = await axios.get(`/api/uncapped`, {
          headers: {
            'Authorization': `Bearer ${this.$store.getters.token}`
          },
          params: {
            now_date: date,
            code: query
          }
        });
        const responseData = response.data;

        if (responseData.stock_data_list == null) {
          this.$message.error(responseData.detail || '不是7095标的');
          this.data = {};
          this.tableData = [];
        } else {
          this.data = responseData;
          this.generateTableData();
          this.containerDisplay = false;
        }
      } catch (error) {
        if (error.response && error.response.data && error.response.data.detail) {
          if (error.response.data.detail.includes('无法验证凭证')) {
            this.$store.dispatch('logout');
            this.$router.push('/login');
          }
          this.$message.error(error.response.data.detail);
        } else {
          this.warring = '数据获取失败，' + (this.data?.error || '未知错误');
        }
      } finally {
        this.isSubmitting = false;
        console.log('请求完成');
      }
    },
      generateTableData() {
      const { date, stock_code, stock_name, stock_data_list } = this.data;
      this.now_str = this.data.now_str;
      this.scode = stock_code ? stock_code.split('.')[0] : '';

      // 确保数据存在后再进行操作
      const dataExists = stock_data_list && Object.keys(stock_data_list).length > 0;

      this.tableData = dataExists ? [
        {
          date,
          stock_code,
          stock_name,
          term: '80%',
          1: stock_data_list[5],
          2: stock_data_list[6],
          3: stock_data_list[7],
          4: stock_data_list[9],
          5: stock_data_list[10],

        },
        {
          date: '',
          stock_code: '',
          stock_name: '',
          term: '85%',
          1: stock_data_list[5],
          2: stock_data_list[12],
          3: stock_data_list[13],
          4: stock_data_list[15],
          5: stock_data_list[16],
        }
      ] : [];
    },
    extractValues(stock_data_list, indices) {
      console.log('indices:', indices);

      return {
        中信_7095: (stock_data_list['中信_7095'] && stock_data_list['中信_7095'][indices[1]] !== undefined)
          ? stock_data_list['中信_7095'][indices[1]]
          : 0,

        银河_7095: (stock_data_list['银河_7095'] && stock_data_list['银河_7095'][indices[0]] !== undefined)
          ? stock_data_list['银河_7095'][indices[0]]
          : 0,
          中金_7095: (stock_data_list['中金_7095'] && stock_data_list['中金_7095'][indices[2]] !== undefined)
          ? stock_data_list['中金_7095'][indices[2]]
          : 0
      };
    },

  }
};
</script>
<styled>


</styled>